@if (user) {
  <div class="card">
    <div class="user-header">
      <span> Account Information </span>
    </div>
    <form [formGroup]="form">
      <div class="user-row">
        <div><strong>User ID:</strong> {{ user._id }}</div>
        <div><strong>Logging ID:</strong> {{ user.user_id }}</div>
      </div>
      <div class="user-row">
        <mat-form-field appearance="outline">
          <mat-label>First Name</mat-label>
          @if (form.get('firstname').errors) {
            <mat-error> {{ getErrorText('firstname') }}</mat-error>
          }
          <input formControlName="firstname" matInput test-id="first-name-input" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Last Name</mat-label>
          @if (form.get('lastname').errors) {
            <mat-error>{{ getErrorText('lastname') }}</mat-error>
          }
          <input formControlName="lastname" matInput test-id="last-name-input" />
        </mat-form-field>
      </div>
      <div class="user-row">
        <mat-form-field appearance="outline">
          <mat-label>Email Address</mat-label>
          <input formControlName="email" matInput test-id="email-input" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Role</mat-label>
          <mat-select formControlName="role" test-id="role-select">
            @for (role of roleOptions; track role) {
              <mat-option [disabled]="role.disabled" [value]="role.value">{{ role.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="user-row" style="align-items: center">
        <mat-slide-toggle
          formControlName="disabled"
          style="flex-grow: 0"
          test-id="disabled-user-toggle"
          [fwTooltip]="form.get('disabled').disabled ? 'You cannot disable your own account.' : null"
        >
          Login Disabled
        </mat-slide-toggle>
        @if (ldapEnabled) {
          <span style="flex-grow: initial" test-id="ldap-warning"
            >LDAP is enabled for this site. The Site Admin role can only be modified through the LDAP service.</span
          >
        }
      </div>
      <div align="end" mat-dialog-actions>
        <button mat-stroked-button test-id="cancel-button" (click)="resetFormGroup()">Cancel</button>
        <button color="primary" mat-flat-button test-id="save-button" [disabled]="!form.valid" (click)="save()">
          Save
        </button>
      </div>
    </form>
  </div>
}
